// @flow

import type {ModalProps} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import GoPencil from 'react-icons/lib/go/pencil'
import {mergeAll} from 'ramda'
import {formActions, uiActions} from '@/store'

type Props = {
  title: string,
  onClick: () => void,
  onSave: () => void,
  clearForm: () => void,
  showEditModal: (props: ModalProps) => void,
  id?: string,
}

export class RawEditButton extends Component<Props> {
  onClick = () => {
    this.props.onClick()
    this.props.showEditModal({
      title: this.props.title,
      onConfirm: this.props.onSave,
    })
  }

  render = () =>
    <a id={this.props.id} onClick={this.onClick}><GoPencil /></a>
}

export default connect(
  null,
  mergeAll([formActions, uiActions]),
)(RawEditButton)



// WEBPACK FOOTER //
// ./src/controls/edit-button.js